import React, { Fragment } from 'react';
import { getRandomUid } from 'utilities/uuid.service';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { FaCalendarAlt } from 'react-icons/fa';
import styles from './style.datepicker.css';
import * as dayjs from 'dayjs';

const DatePicker = ({
  handleDatePicker,
  showDatePicker,
  handleDayClick,
  labelProps = {},
  inputProps = {},
  fieldErrors = {},
}) => {
  const { label = ' TextField label', ...rest } = labelProps;
  const { id, className = '', ...props } = inputProps;

  const textFieldID = id ?? getRandomUid();

  let selectBoxClasses = '';
  const { errorMessage = '' } = fieldErrors;

  if (errorMessage) {
    selectBoxClasses = 'border border-danger';
  }
  return (
    <Fragment>
      <label htmlFor={textFieldID} {...rest}>
        {label}
      </label>
      <input
        type="text"
        placeholder="dd-mm-yyyy"
        id={textFieldID}
        className={`${className} ${selectBoxClasses} input-field`}
        {...props}
      />
      <span className="date-icon" onClick={handleDatePicker}>
        <FaCalendarAlt />
      </span>
      {showDatePicker && (
        <DayPicker
          onDayClick={(day) => {
            const date = dayjs(day).format('YYYY-MM-DD');
            handleDayClick(date);
          }}
        />
      )}
    </Fragment>
  );
};

export default DatePicker;
